import React from 'react';
import iconStyles from '../../styles/icons/virtualIcon.scss';
import styles from '../../styles/nvIcons.scss';
const VirtualIcon = (props) => (React.createElement("i", Object.assign({}, props, { className: `${props.className} ${styles.nv_icon_call_forward} ${iconStyles.icon}` })));
export default VirtualIcon;
